export function computeLoadingPercent(loaded: number, total: number): number {
  if (total > 0) {
    return Math.min(100, Math.round((loaded / total) * 100));
  }
  return loaded ? 100 : 0;
}
